import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Collapse, Label, Input, FormGroup} from 'reactstrap';
import {find, some, remove} from 'lodash';
import {apiPost} from '../../utils/request';
import {toastr} from 'react-redux-toastr';
import {
  BASE_URL, EMPTY_GUID, HandleFieldChange, IsStringValid, URL_NewUser, ValidateStateKeys,
  validationCreator
} from '../../constants';
import { push, go } from '../../utils/navigation';
import {NewClient} from "./EditClientView";
import {NewLocation} from "../Location/EditLocationView";
import TextBoxControl from "../Common/TextBoxControl";
import CheckBoxControl from "../Common/CheckBoxControl";
import AddressesView from "../Addresses/AddressesView";
import CommunicationsView from "../Communications/CommunicationsView";
import UserAuthenticationRequestsControl from "../Users/UserAuthenticationRequestsControl";
import {RadioGroup, Radio} from 'react-radio-group';
import '../../assets/attachments/2018_SRS_Terms_Short.pdf';
import ExistingClientLocaion from "../Common/ExistingClientLocation";


const ValidationRules = {
  client: {
    companyName: {
      validator: (val, state, props) => {
        return !IsStringValid(val) ? validationCreator(false, 'Please enter a valid company name') : validationCreator();
      }
    },
    abn: {
      validator: (val, state, props) => {
        return !IsStringValid(val, /^(\d *?){11}$/g) ? validationCreator(false, 'Please enter a valid abn') : validationCreator();
      }
    },
  },
  location: {
    locationName: {
      validator: (val, state, props) => {
        return !IsStringValid(val) ? validationCreator(false, 'Please enter a valid location name') : validationCreator();
      }
    },
    abn: {
      validator: (val, state, props) => {
        return !IsStringValid(val, /^(\d *?){11}$/g) ? validationCreator(false, 'Please enter a valid abn') : validationCreator();
      }
    },
    locationTinTankType: {
      validator: (val, state, props) => {
        return val == '' ? validationCreator(false, 'Please select a location storage option') : validationCreator();
      }
    },
    estimatedLitresPerDay: {
      validator: (val, state, props) => {
        return !IsStringValid(val, /^(\d*)$/g) || val > 1000 ? validationCreator(false, 'Please enter a estimate of usage') : validationCreator();
      }
    }
  }
};

class NewClientLocationPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    let client = {...NewClient(true)};

    let location = {...NewLocation()};

    this.state = {
      client,
      location,
      validationMessages: {},
      mode: 'client',
      acceptTerms: false,
      messages: [],
      saving: false,
    };

    this.handleClientFieldChange = this.handleClientFieldChange.bind(this);
    this.handleLocationFieldChange = this.handleLocationFieldChange.bind(this);
    this.validate = this.validate.bind(this);
    this.validateClient = this.validateClient.bind(this);
    this.validateLocation = this.validateLocation.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.copyFromClient = this.copyFromClient.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.clientAddressesRef = React.createRef();
    this.locationAddressesRef = React.createRef();
    this.clientCommsRef = React.createRef();
    this.locationCommsRef = React.createRef();
  }


  handleClientFieldChange(e) {
    HandleFieldChange(e, 'client', this, () => this.validate());
  }

  handleLocationFieldChange(e) {
    HandleFieldChange(e, 'location', this, () => this.validate());
  }

  validate(){
    return ValidateStateKeys(['client', 'location'], this, ValidationRules);
  }

  validateClient(){
    let returnVal = ValidateStateKeys(['client'], this, ValidationRules);
    if(returnVal) {
      let addresses = this.clientAddressesRef.current.getCurrentState();
      let communications = this.clientCommsRef.current.getCurrentState();
      let messages = [];

      if (addresses === null || addresses[0].line1 === '') {
        messages.push('Please complete address details');
      }
      if (communications === null || communications.length === 0) {
        messages.push('Please enter at least one communication method');
      }

      this.setState({messages});
      if (messages.length > 0) {
        return false;
      }
    }
    return returnVal;
  }

  validateLocation(){
    let returnVal =  ValidateStateKeys(['location'], this, ValidationRules);
    let {location} = this.state;

    if(returnVal) {
      let addresses = this.locationAddressesRef.current.getCurrentState();
      let communications = this.locationCommsRef.current.getCurrentState();
      let messages = [];

      if (addresses === null || addresses[0].line1 === '') {
        messages.push('Please complete address details');
      }
      if (communications === null || communications.length === 0) {
        messages.push('Please enter at least one communication method');
      }
      if(location.isSmsAccepted && (communications === null || communications.findIndex(x => x.communicationType === 'Sms Phone'
        && x.detail.startsWith('04')) < 0)){
        messages.push('You have selected Accept SMS, please include an SMS phone number in communications, starting with 04...');
      }

      this.setState({messages});
      if (messages.length > 0) {
        return false;
      }
    }
    return returnVal;
  }

  handleSave() {
    if (!this.validate()) {
      return;
    }
    this.setState({saving: true}, () => {
      apiPost('/api/clients/newclientlocation', {
        client: {...this.state.client},
        location: {...this.state.location},
      }).then(x => {
        //TODO: Check the returned client/location, create a authrequest for the current user to the client

        if(x.error){
          x.data.json().then(a => toastr.error(a.message));
        } else {

          let authRequest = {
            toLocationId: null,
            toClientId: x.data.client.id,
            requestedByUserId: this.props.account.user.id,
            originalRequestInfo: null,
          };

          apiPost('/api/AuthorisationRequests/create', authRequest)
            .then(x => {
              this.setState({saving: false});
              if (x.error) {
                x.data.json().then(a => toastr.error(a.message));
              } else {
                this.setState({mode: 'saved'});
                setTimeout(() => {
                  toastr.success('Success! Your request has been processed, once the client and location is approved, you will receive an email confirming your access');
                  this.props.dispatch(push(URL_NewUser));
                }, 1000);
              }
            });
        }
      });
    });
  }

  copyFromClient(e){
    e.preventDefault();

    let {location, client} = this.state;
    location.addresses = [...client.addresses];
    location.communications = [...client.communications];
    location.locationName = client.companyName;
    location.abn = client.abn;
    this.setState({location}, this.validateLocation);
  }


  handleChange(e){
    this.setState({location:{...this.state.location, locationTinTankType: e}}, this.validateLocation);
  }

  render(){
    let {client, location, validationMessages, mode, messages, saving} = this.state;

    return (<div>

      <Collapse isOpen={mode==='client'}>
        <div className="form-group row" style={{marginLeft: '0px'}}>
          <h4>Client Information</h4>
        </div>
        <TextBoxControl
          value={client.companyName}
          onChange={this.handleClientFieldChange}
          name="companyName"
          labelText="Company Name"
          validationMessages={validationMessages.client}
        />
        <div className="form-group row">
          <div className="col-8 offset-2">
            <ExistingClientLocaion name={client.companyName} mode={'location'} />
          </div>
        </div>

        <TextBoxControl
          value={client.abn}
          onChange={this.handleClientFieldChange}
          name="abn"
          labelText="Client ABN"
          validationMessages={validationMessages.client}
        />

        <AddressesView
          addresses={client.addresses}
          ref={this.clientAddressesRef}
          onChange={(addresses)=> this.setState({client: {...this.state.client, addresses}}, this.validateClient)}
          enableDelete={false}
          enableAdd={false}
          enableAddressType={false}
          enableIsPrimary={false}
        />

        <CommunicationsView
          communications={client.communications}
          ref={this.clientCommsRef}
          onChange={(communications)=> this.setState({client: {...this.state.client, communications}}, this.validateClient)}
        />

        <Button color={'secondary'} onClick={()=> {
          this.props.dispatch(go(-1));
        }}>Cancel</Button>&nbsp;&nbsp;

        <Button color={'primary'} onClick={()=> {
          if(this.validateClient()) {
            this.setState({mode: 'location'});
          }
        }}>Next</Button>
      </Collapse>

      <Collapse isOpen={mode==='location'}>
        <div className="form-group row" style={{marginLeft: '0px'}}>
          <h4>Location Information</h4>
        </div>
        <div className="form-group row" style={{marginLeft: '0px'}}>
          <h5><a href={'#'} onClick={this.copyFromClient}>Copy from Client details</a></h5>
        </div>
        <TextBoxControl
          value={location.locationName}
          onChange={this.handleLocationFieldChange}
          name="locationName"
          labelText="Location Name"
          validationMessages={validationMessages.location}
        />
        <div className="form-group row">
          <div className="col-8 offset-2">
            <ExistingClientLocaion name={location.locationName} mode={'location'} />
          </div>
        </div>

        <TextBoxControl
          value={location.buildingName}
          onChange={this.handleLocationFieldChange}
          name="buildingName"
          labelText="Building Name"
          validationMessages={validationMessages.location}
        />

        <TextBoxControl
          value={location.abn}
          onChange={this.handleLocationFieldChange}
          name="abn"
          labelText="Location ABN"
          validationMessages={validationMessages.location}
        />

        <CheckBoxControl
          name={'isSmsAccepted'}
          value={location.isSmsAccepted}
          onChange={this.handleLocationFieldChange}
          labelText={'Is SMS Accepted'}
        />

        <div className="form-group row">
          <label className="col-md-2 col-xs-3 col-sm-3 form-control-label" htmlFor={'locationTinTankType'}>Location Storage</label>
          <div className="col-md-10 col-xs-10 col-sm-10 ">
            <RadioGroup name="locationTinTankType" selectedValue={location.locationTinTankType} onChange={this.handleChange}>
              <Radio value={'TinOnly'} /><span onClick={() => this.handleChange('TinOnly')} style={{marginLeft: '5px', marginRight: '15px', cursor: 'pointer'}}>Tin Only</span>
              <Radio value={'TankOnly'} /><span onClick={() => this.handleChange('TankOnly')} style={{marginLeft: '5px', marginRight: '15px', cursor: 'pointer'}}>Tank Only</span>
              <Radio value={'TankWithHeater'} /><span onClick={() => this.handleChange('TankWithHeater')} style={{marginLeft: '5px', cursor: 'pointer'}}>Tank + Heater</span>
            </RadioGroup>

            { validationMessages && validationMessages.location && (validationMessages.location.locationTinTankType !== '' || validationMessages.location.locationTinTankType !== undefined) &&
            <div style={{color: 'red'}}>{validationMessages.location.locationTinTankType}</div> }
          </div>
        </div>

        <TextBoxControl
          value={location.estimatedLitresPerDay}
          onChange={this.handleLocationFieldChange}
          name="estimatedLitresPerDay"
          labelText="Estimated Litres Per Day"
          validationMessages={validationMessages.location}
          type={'number'}
        />

        <AddressesView
          addresses={location.addresses}
          ref={this.locationAddressesRef}
          onChange={(addresses)=> this.setState({location: {...this.state.location, addresses}}, this.validateLocation)}
          enableDelete={false}
          enableAdd={false}
          enableAddressType={false}
          enableIsPrimary={false}
        />

        <CommunicationsView
          communications={location.communications}
          ref={this.locationCommsRef}
          onChange={(communications)=> this.setState({location: {...this.state.location, communications}}, this.validateLocation)}
        />

        <Button color={'secondary'} onClick={()=> this.setState({mode: 'client', messages: []})}>Back</Button>&nbsp;
        <Button color={'primary'} onClick={()=> {
          if(this.validateLocation()) {
            this.setState({mode: 'terms'});
          }
        }}>Next</Button>
      </Collapse>

      <Collapse isOpen={mode==='terms'}>
        <div className="form-group row" style={{marginLeft: '0px'}}>
          <h4>Terms of Use</h4>
        </div>

        <div className="form-group row">
          <label className="col-md-2 form-control-label"  htmlFor={'acceptTerms'}>
            <a href={`${BASE_URL}/assets/attachments/2018_SRS_Terms_Short.pdf`} target={'_blank'}>Accept Terms of Use</a>
          </label>
          <div className="col-md-8">
            <FormGroup check>
              <Label check>
                <Input type="checkbox"
                       onChange={this.handleLocationFieldChange}
                       checked={location.acceptTerms}
                       name="acceptTerms"
                       disabled={false}
                />
              </Label>
            </FormGroup>
          </div>
        </div>

        <div>&nbsp;</div>
        {!saving && <Button color={'secondary'} onClick={()=> this.setState({mode: 'location', messages: []})}>Back</Button>}&nbsp;
        {!saving && location.acceptTerms && <Button color={'success'} onClick={()=> this.handleSave()}>Save</Button>}
        {saving && <div>Saving...</div> }
      </Collapse>

      <Collapse isOpen={mode==='saved'}>
        <ul className={'list-group'} style={{marginTop: '15px'}}>
          <ul className={'list-group-item list-group-item-success'}>Success! Your request has been processed, once the client and location is approved, you will receive an email confirming your access</ul>
        </ul>

        {mode==='saved' && <UserAuthenticationRequestsControl
          showUserPhoneWarning={true}
          account={this.props.account}
          userId={this.props.account.user.id}
          requestsUpdated={() => {}}/> }

      </Collapse>

      <ul className={'list-group'} style={{marginTop: '15px'}}>
        {messages.map((x, i) => (<ul className={'list-group-item list-group-item-danger'} key={i}>{x}</ul>))}
      </ul>

    </div>);
  }
}

NewClientLocationPage.propTypes = {

};

function mapStateToProps(state){
  return {
    account: state.account,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewClientLocationPage);
